import PropTypes from 'prop-types';
import React from 'react';
import crypto from 'crypto';
import Tooltip from 'react-aria-tooltip';

export default function Avatar({ email }) {
    // You HAVE to lower case email addresses for them to work with gravatar. I
    // have contacted too many websites about broken implementations for us to
    // make the same mistake
    email = email.toLowerCase();
    const hash = crypto
        .createHash('md5')
        .update(email)
        .digest('hex');

    const src = `https://www.gravatar.com/avatar/${hash}?d=identicon`;
    const altValue = `Gravatar image for ${email}`;
    return (
        <Tooltip message="click image to change avatar" eventType="hover">
            <a
                href="https://gravatar.com"
                target="_blank"
                rel="noopener noreferrer"
                role="button"
            >
                <img src={src} className="avatar" alt={altValue} />
            </a>
        </Tooltip>
    );
}
Avatar.propTypes = {
    email: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/avatar.ui.jsx